import { NextPage } from 'next';

import { PillarGenericPage } from '~/components/pillar-generic-page';

import DigitalAssessmentPageLogo from '../../../public/digital-assessment-page-logo.png';

const DigitalAssessmentPage: NextPage = () => (
  <PillarGenericPage
    title="desenho e estruturação do negócio"
    description="Digital Assessment"
    subdescription="Destinado à empresas que estão começando no digital ou querem tirar os planos do papel"
    image={DigitalAssessmentPageLogo}
    paragraphs={[
      {
        main: 'Benchmarks',
        content:
          'Comparar e avaliar o desempenho, práticas ou resultados de uma organização em relação aos concorrentes ou padrões estabelecidos, com o objetivo de identificar oportunidades de melhoria e alcançar excelência.',
      },
      {
        main: 'Análise de Mercado e Concorrência',
        content: 'não seria a mesma coisa que benchmark?',
        greenContent: true,
      },
      {
        main: 'Deep diving estratégia',
        content:
          'Abordagem que envolve uma análise minuciosa e abrangente dos elementos-chave do negócio, permitindo às empresas compreenderem profundamente o ambiente competitivo e identificarem oportunidades estratégicas para impulsionar o crescimento e a vantagem competitiva.',
      },
      {
        main: 'Infraestrutura de Tecnológica',
        content:
          'é a espinha dorsal das operações digitais de uma empresa, proporcionando a base sólida necessária para suportar e impulsionar a inovação, a eficiência e o crescimento sustentável.',
      },
      {
        main: 'Desenho de modelo de negócio',
        content:
          'Desenhar o modelo de negócios de uma empresa é como esculpir o seu DNA empresarial, definindo os elementos essenciais que moldam sua estratégia, operações e proposta de valor, para alcançar o sucesso no mercado.',
      },
      {
        main: 'Business Case',
        content: 'o que seria isso?',
        greenContent: true,
      },
      {
        main: 'Estrutura Organizacional',
        content:
          'Montar uma estrutura organizacional é como construir os alicerces de uma casa, garantindo uma base sólida para o crescimento e a eficiência, ao definir claramente as responsabilidades, hierarquias e fluxos de comunicação dentro da empresa.',
      },
    ]}
  />
);

export default DigitalAssessmentPage;
